import React from 'react'
import ImageDescription from 'components/Slides/ImageDescription'

export default ImageDescription({
  heading: 'We’ll be using loops a lot…',
  description: () => (
    <div>
      <p>
        Loops are something we have in almost all coding languages. We take a list of items and loop through each item and do something with it.
      </p>
      <p>
        Right now we’re looping through all of our WordPress posts, but next week
        we’ll see how we can customise what posts we loop through and where.
      </p>
    </div>
  ),
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/06-loop-summary.js